
import * as appConfig from '../env/production.config';

const staffConfigModule = { segmentConfig: {}, ...appConfig };

if (process.env.LOG_DEBUG_ENABLED) {
  staffConfigModule.logDebugEnabled = process.env.LOG_DEBUG_ENABLED === 'true';
}

if (process.env.SEGMENT_API_KEY && process.env.SEGMENT_API_KEY !== '') {
  staffConfigModule.segmentConfig.apiKey = process.env.SEGMENT_API_KEY;
} else {
  // no api key given - prevent segment from being used
  staffConfigModule.segmentConfig = {};
}

if (process.env.API_URL) {
  staffConfigModule.apiUrl = process.env.API_URL;
}
if (process.env.ATATUS_API_KEY) {
  staffConfigModule.atatusApiKey = process.env.ATATUS_API_KEY;
}

const module = angular.module('staffConfig', []);

Object.entries(appConfig).forEach(([key, value]) => {
  module.constant(key, value);
});

export default 'staffConfig';
